module.exports = __webpack_public_path__ + "static/media/nombre-apellido.f0207571.svg";